import { render, staticRenderFns } from "./CreateEventDisplayMode.vue?vue&type=template&id=5552e5d1&scoped=true"
import script from "./CreateEventDisplayMode.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEventDisplayMode.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateEventDisplayMode.vue?vue&type=style&index=0&id=5552e5d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552e5d1",
  null
  
)

export default component.exports